var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessPaymentCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.3463 3.17025C57.2469 1.14038 62.7531 1.14037 67.6537 3.17025L94.7727 14.4033C99.6733 16.4332 103.567 20.3267 105.597 25.2273L116.83 52.3463C118.86 57.2469 118.86 62.7531 116.83 67.6537L105.597 94.7727C103.567 99.6733 99.6733 103.567 94.7727 105.597L67.6537 116.83C62.7531 118.86 57.2469 118.86 52.3463 116.83L25.2273 105.597C20.3267 103.567 16.4332 99.6733 14.4033 94.7727L3.17025 67.6537C1.14038 62.7531 1.14037 57.2469 3.17025 52.3463L14.4033 25.2273C16.4332 20.3267 20.3267 16.4332 25.2273 14.4033L52.3463 3.17025Z",
    fill: "#1E016F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3463 13.1703C57.2469 11.1404 62.7531 11.1404 67.6537 13.1703L87.7017 21.4744C92.6022 23.5043 96.4957 27.3978 98.5256 32.2983L106.83 52.3463C108.86 57.2469 108.86 62.7531 106.83 67.6537L98.5256 87.7017C96.4957 92.6022 92.6022 96.4957 87.7017 98.5256L67.6537 106.83C62.7531 108.86 57.2469 108.86 52.3463 106.83L32.2983 98.5256C27.3978 96.4957 23.5043 92.6022 21.4744 87.7017L13.1703 67.6537C11.1404 62.7531 11.1404 57.2469 13.1703 52.3463L21.4744 32.2983C23.5043 27.3978 27.3978 23.5043 32.2983 21.4744L52.3463 13.1703Z",
    fill: "#7647EE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42 60L54 72L78 48",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessPaymentCheck);
export default __webpack_public_path__ + "static/media/success-payment-check.40f61d44f052816ff650a2de8ff908e9.svg";
export { ForwardRef as ReactComponent };